"use client";

import { c as _c } from "react/compiler-runtime";
import { fullScreenSupported } from "@/helpers/Helpers";
import { ArrowDownTrayIcon, ArrowTopRightOnSquareIcon, ArrowsPointingOutIcon, XMarkIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import type React from "react";
const BASE_BUTTON_CLASS = "tw-inline-flex tw-size-9 tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-text-iron-100 tw-transition tw-duration-200 desktop-hover:hover:tw-bg-iron-700 disabled:tw-cursor-default disabled:tw-opacity-60";
function ToolbarButton(t0) {
  const $ = _c(8);
  const {
    label,
    onClick,
    disabled: t1,
    children,
    className
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className) {
    t2 = clsx(BASE_BUTTON_CLASS, className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== disabled || $[4] !== label || $[5] !== onClick || $[6] !== t2) {
    t3 = <button type="button" aria-label={label} title={label} onClick={onClick} disabled={disabled} className={t2}>{children}</button>;
    $[2] = children;
    $[3] = disabled;
    $[4] = label;
    $[5] = onClick;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
const stopAndRun = (handler: () => void) => (event: React.MouseEvent<HTMLButtonElement>) => {
  event.stopPropagation();
  handler();
};
export function InlineMediaActions(t0) {
  const $ = _c(21);
  const {
    onDownload,
    onOpen,
    onFullscreen,
    openLabel,
    isDownloading,
    fullscreenTargetAvailable,
    variant
  } = t0;
  let t1;
  if ($[0] !== fullscreenTargetAvailable || $[1] !== onFullscreen || $[2] !== variant) {
    t1 = variant === "image" && Boolean(onFullscreen) && Boolean(fullscreenTargetAvailable) && fullScreenSupported();
    $[0] = fullscreenTargetAvailable;
    $[1] = onFullscreen;
    $[2] = variant;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const canFullscreen = t1;
  let t2;
  if ($[4] !== canFullscreen || $[5] !== onFullscreen) {
    t2 = canFullscreen && <ToolbarButton label="Full screen" onClick={stopAndRun(onFullscreen)}><ArrowsPointingOutIcon className="tw-size-4" aria-hidden="true" /></ToolbarButton>;
    $[4] = canFullscreen;
    $[5] = onFullscreen;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== onOpen || $[8] !== openLabel) {
    t3 = onOpen && openLabel && <ToolbarButton label={openLabel} onClick={stopAndRun(onOpen)}><ArrowTopRightOnSquareIcon className="tw-size-4" aria-hidden="true" /></ToolbarButton>;
    $[7] = onOpen;
    $[8] = openLabel;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = isDownloading ? "Downloading media" : "Download media";
  let t5;
  if ($[10] !== onDownload) {
    t5 = stopAndRun(onDownload);
    $[10] = onDownload;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ArrowDownTrayIcon className="tw-size-4" aria-hidden="true" />;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== isDownloading || $[14] !== t4 || $[15] !== t5) {
    t7 = <ToolbarButton label={t4} onClick={t5} disabled={isDownloading}>{t6}</ToolbarButton>;
    $[13] = isDownloading;
    $[14] = t4;
    $[15] = t5;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t2 || $[18] !== t3 || $[19] !== t7) {
    t8 = <div className="tw-absolute tw-right-[5px] tw-top-[5px] tw-z-30 tw-flex tw-overflow-hidden tw-rounded-lg tw-bg-iron-950/90 tw-shadow-lg tw-shadow-black/20 tw-ring-1 tw-ring-inset tw-ring-iron-700/60 tw-backdrop-blur">{t2}{t3}{t7}</div>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}
export function ExpandedMediaToolbar(t0) {
  const $ = _c(31);
  const {
    onOpen,
    onDownload,
    onFullscreen,
    onClose,
    openLabel,
    isDownloading,
    fullscreenTargetAvailable
  } = t0;
  let t1;
  if ($[0] !== fullscreenTargetAvailable || $[1] !== onFullscreen) {
    t1 = Boolean(onFullscreen) && Boolean(fullscreenTargetAvailable) && fullScreenSupported();
    $[0] = fullscreenTargetAvailable;
    $[1] = onFullscreen;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const canFullscreen = t1;
  let t2;
  if ($[3] !== canFullscreen || $[4] !== onFullscreen) {
    t2 = canFullscreen && <ToolbarButton label="Full screen" onClick={stopAndRun(onFullscreen)}><ArrowsPointingOutIcon className="tw-size-5" aria-hidden="true" /></ToolbarButton>;
    $[3] = canFullscreen;
    $[4] = onFullscreen;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== onOpen) {
    t3 = stopAndRun(onOpen);
    $[6] = onOpen;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ArrowTopRightOnSquareIcon className="tw-size-5" aria-hidden="true" />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== openLabel || $[10] !== t3) {
    t5 = <ToolbarButton label={openLabel} onClick={t3}>{t4}</ToolbarButton>;
    $[9] = openLabel;
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = isDownloading ? "Downloading media" : "Download media";
  let t7;
  if ($[12] !== onDownload) {
    t7 = stopAndRun(onDownload);
    $[12] = onDownload;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ArrowDownTrayIcon className="tw-size-5" aria-hidden="true" />;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isDownloading || $[16] !== t6 || $[17] !== t7) {
    t9 = <ToolbarButton label={t6} onClick={t7} disabled={isDownloading}>{t8}</ToolbarButton>;
    $[15] = isDownloading;
    $[16] = t6;
    $[17] = t7;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t2 || $[20] !== t5 || $[21] !== t9) {
    t10 = <div className="tw-flex tw-overflow-hidden tw-rounded-xl tw-bg-iron-900/95 tw-shadow-lg tw-shadow-black/30 tw-ring-1 tw-ring-inset tw-ring-iron-700/70 tw-backdrop-blur">{t2}{t5}{t9}</div>;
    $[19] = t2;
    $[20] = t5;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== onClose) {
    t11 = stopAndRun(onClose);
    $[23] = onClose;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <XMarkIcon className="tw-size-5" aria-hidden="true" />;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11) {
    t13 = <button type="button" aria-label="Close media" title="Close media" onClick={t11} className="tw-inline-flex tw-size-9 tw-items-center tw-justify-center tw-rounded-xl tw-border-0 tw-bg-iron-900/95 tw-text-iron-100 tw-shadow-lg tw-shadow-black/30 tw-ring-1 tw-ring-inset tw-ring-iron-700/70 tw-backdrop-blur tw-transition tw-duration-200 desktop-hover:hover:tw-bg-iron-700">{t12}</button>;
    $[26] = t11;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t10 || $[29] !== t13) {
    t14 = <div className="tw-fixed tw-right-4 tw-top-3 tw-z-[1102] tw-flex tw-items-center tw-gap-x-3 tw-pt-[env(safe-area-inset-top,0px)]">{t10}{t13}</div>;
    $[28] = t10;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
}